import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { TableExpandedRow } from '@helsenorge/designsystem-react/components/Table';
export class ExpandableRow extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "rowRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "toggleClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.props.expandableRowKey && this.props.toggle) {
                    this.props.toggle(this.props.expandableRowKey);
                }
            }
        });
        this.rowRef = React.createRef();
    }
    render() {
        const { className, children, rowData, open, colspan, hideDetailsText, tableId, expandableRowKey } = this.props;
        let childrenElement;
        if (children) {
            if (React.isValidElement(children)) {
                const props = {
                    rowData: rowData,
                    expanded: open,
                };
                childrenElement = React.cloneElement(children, props);
            }
            else {
                childrenElement = children;
            }
        }
        return (_jsx(TableExpandedRow, { expanded: !!open, numberOfColumns: colspan || 1, hideDetailsText: hideDetailsText || '', toggleClick: this.toggleClick, id: `${tableId}-${expandableRowKey}`, className: className, children: _jsx(_Fragment, { children: childrenElement }) }, `${tableId}-${expandableRowKey}`));
    }
}
Object.defineProperty(ExpandableRow, "isExpandableRow", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: true
});
